import { render, staticRenderFns } from "./system_management_section.vue?vue&type=template&id=392fd0fe&scoped=true"
import script from "./system_management_section.vue?vue&type=script&lang=js"
export * from "./system_management_section.vue?vue&type=script&lang=js"
import style0 from "./system_management_section.vue?vue&type=style&index=0&id=392fd0fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392fd0fe",
  null
  
)

export default component.exports